import React, { Suspense } from "react";
// import { BrowserRouter, Route, Routes } from "react-router-dom";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { pvrTheme, inoxTheme } from "./theme/themes";
import PAYMENT from "./views/payment/Payment";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css"; //icons
import "bootstrap/dist/css/bootstrap.min.css";
import "./custom-style/style.css"; // == global styling
import "./custom-style/queries.css"; // == global styling
import "./custom-style/mobilequeries.css"; // == global styling
import { cinemaChain } from "./constants";
import { HelmetProvider, Helmet } from "react-helmet-async";
import ReactGA from "react-ga";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);



// ==== mobile views pages end rountes ============

const Home = React.lazy(() => import("./views/static-pages/advertise/Advertise"));
const SeatLayoutWchat = React.lazy(() =>
  import("./views/seat-layout/SeatLayoutWchat")
);
const TSSHome = React.lazy(() => import("./views/Tss/TssHome"));
const Contest = React.lazy(() => import("./views/contest/Contest"));
const AvatarMovie = React.lazy(() => import("./views/contest/AvtarBrand"));
const Spiderman = React.lazy(() => import("./views/contest/SpiderMan"));



const PageNotFound = React.lazy(() =>
  import("./views/page-not-found/PageNotFound")
);

//Re-release Poll
const ReReleasePoll = React.lazy(() => import("./views/release-poll/release-poll"));
const ReReleasePollThank = React.lazy(() => import("./views/release-poll/thank-you"));
const AddToGoogleWallet = React.lazy(() => import("./views/googlewallet/Googlewallet"));
const AddToGoogleWalletoffline = React.lazy(() => import("./views/googlewallet/Googlewalletoffline"));
const Mandate = React.lazy(() => import("./views/mandate/Mandate"));
const MandateSuccess = React.lazy(() => import("./views/mandate/MandateSuccess"));
const MandateError = React.lazy(() => import("./views/mandate/MandateError"));
const AddToWhatusupBot = React.lazy(() => import("./views/googlewallet/WhatsupBot"));
const KotakCampgain = React.lazy(() => import("./views/googlewallet/Kotakcampagain"));
const KotakCards = React.lazy(() => import("./views/googlewallet/KotakCards"));


function App() {
  const themeVal = cinemaChain === "PVR" ? "pvrTheme" : "inoxTheme";
  localStorage.setItem("theme", themeVal);
  const theme = cinemaChain === "PVR" ? pvrTheme : inoxTheme;
  if (cinemaChain === "PVR") ReactGA.initialize("G-CPXWTKDXV8");
  else ReactGA.initialize("G-FYEYSCFLNJ");

  // localStorage.setItem("city", "Delhi-NCR");
  if (!localStorage.getItem("lat")) {
    localStorage.setItem("lat", "0.000");
    localStorage.setItem("long", "0.000");
  }
  const Ticket = React.lazy(() => import("./views/final-ticket/FinalTicket"));
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet>
          <title>{cinemaChain === "PVR" ? "PVR INOX WEB" : "PVR INOX WEB"}</title>
          <link
            rel="icon"
            href={cinemaChain === "PVR" ? "/pvr.ico" : "/inox.ico"}
          />
          <meta name="description" content="PVR INOX WEB" />
        </Helmet>
        <ThemeProvider theme={theme}>
          {/* <BrowserRouter> */}
          <Suspense fallback={loading}>
            <Router>
              <Routes>
                <Route path="tss" name="Home" element={<TSSHome />} />                
                <Route path="pushpha-two-guide" name="Home" element={<Contest />} />
                <Route path="avatar-guide" name="Home" element={<AvatarMovie />} />
                 <Route path="spiderman" name="Home" element={<Spiderman />} />
                <Route
                  path="/seatlayout-wchat/:encrypted_id"
                  name="Seat Layout"
                  element={<SeatLayoutWchat />}
                />
                <Route
                  path="*"
                  name="Page not found"
                  element={<PageNotFound />}
                />

                <Route path="/re-release-poll" name="Rereleasepoll" element={<ReReleasePoll />} />
                <Route path="/re-release-poll-thank" name="Rereleasepoll" element={<ReReleasePollThank />} />
                <Route path="/google-wallet/:bookingid" name="Add Google Wallet" element={<AddToGoogleWallet />} />
                <Route path="/google-wallet/offline/:bookingid" name="Add Google Wallet Offline" element={<AddToGoogleWalletoffline />} />
                <Route path="/mjbot" name="WhatsupBot" element={<AddToWhatusupBot />} />
                <Route path="/kotak-campaign" name="kotak Campaign" element={<KotakCampgain />} />
                <Route path="/kotak-cards" name="kotak Cards" element={<KotakCards />} />
                 <Route path="/mandate" name="Mandate" element={<Mandate />} />
                <Route path="/mandate-success" name="Mandate Success" element={<MandateSuccess />} />
                <Route path="/mandate-error" name="Mandate Error" element={<MandateError />} />


              </Routes>
            </Router>
          </Suspense>
          {/* </BrowserRouter> */}
        </ThemeProvider>
      </HelmetProvider>
    </React.Fragment>
  );
}

export default App;
